// extracted by mini-css-extract-plugin
module.exports = {"form-divider":"FormDivider_form-divider__29Vrv","text-divider":"FormDivider_text-divider__GoMZs"};